var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isIdentityFirstFlow)?_c('UserResetPasswordController',{attrs:{"mfaType":_vm.mfaType,"requestKey":_vm.requestKey,"step":_vm.step}}):_c('UserResetPassword',_vm._b({},'UserResetPassword',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }